import errorBoundary from '@ifeng-fe/errorBoundary';
import React from 'react';
import { handleCallNewsApp, h5PageCount } from 'ThreeTerminal_utils';
import styles from './index.css';

class Layout extends React.PureComponent {
    handleOnClick = () => {
        h5PageCount([
            {
                behavior: 'action',
                type: 'withopen',
                other: {
                    ref: encodeURIComponent(document.referrer),
                    url: encodeURIComponent(location.href),
                },
            },
        ]);
        const nodata = 'nodata';
        const doc_type = 'awake';
        const aid = '';

        const to_url = '';
        const download = {
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1447785374780',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8778',
        };

        handleCallNewsApp(
            nodata,
            doc_type,
            aid,
            to_url,
            0,
            0,
            'inter_fxy05',
            {
                noPrefixKind: true,
            },
            download,
        );
    };

    componentDidMount() {
        const startTime = new Date().getTime();

        window.addEventListener('load', () => {
            window.addEventListener(
                'popstate',
                () => {
                    const endTime = new Date().getTime();

                    if (endTime - startTime > 200) {
                        location.reload();
                    }
                },
                false,
            );
        });
    }
    render() {
        return (
            <div className={styles.pageBody}>
                <img
                    className={styles.banner}
                    src="//x0.ifengimg.com/cmpp/2020/0102/bf74b2e01a4e38asize40_w760_h953.jpg"
                />
                <div className={styles.pageBottom}>
                    <img
                        className={styles.botton}
                        onClick={this.handleOnClick}
                        src="http://x0.ifengimg.com/cmpp/2020/0102/e11dbbce15e13basize7_w514_h79.png"
                    />
                    <img
                        className={styles.bottomPic}
                        src="http://x0.ifengimg.com/cmpp/2020/0102/cf59c6acd7e0af4size4_w760_h398.jpg"
                    />
                </div>
            </div>
        );
    }
}

export default errorBoundary(Layout);
